import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4">LG Concrete Pumping & Stone</h3>
            <p className="text-yellow-500 text-sm font-semibold mb-4">
              Building Foundations, Creating Legacies
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Trusted provider of concrete pumping and stone services in Otto, NC and surrounding areas. Delivering efficient, precise solutions for residential and commercial projects.
            </p>
            <a
              href="https://www.facebook.com/p/LG-Concrete-Pumping-Stone-61572378585686"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-10 h-10 bg-yellow-500 rounded-full text-black hover:bg-yellow-400 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4 border-b-2 border-yellow-500 inline-block pb-1">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="text-gray-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
                  Schedule
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4 border-b-2 border-yellow-500 inline-block pb-1">
              Services
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Concrete Pumping</li>
              <li className="text-gray-400 text-sm">Stone Installation</li>
              <li className="text-gray-400 text-sm">Block Filling</li>
              <li className="text-gray-400 text-sm">Custom Masonry</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4 border-b-2 border-yellow-500 inline-block pb-1">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="tel:8286341304"
                className="flex items-center gap-3 text-yellow-500 text-xl font-bold hover:text-yellow-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                (828) 634-1304
              </a>
              <a
                href="mailto:nicholas.list19@gmail.com"
                className="flex items-center gap-3 text-white text-sm hover:text-yellow-500 transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-yellow-500"></i>
                nicholas.list19@gmail.com
              </a>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <i className="ri-map-pin-fill text-yellow-500 mt-1"></i>
                <span>Otto, NC</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-yellow-500">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 LG Concrete Pumping & Stone LLC. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;